// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('categoryCacheService',

export default function CategoryCacheService() {
    let _productCategories = null;

    this.setCategories = function (productCategories) {
        _productCategories = productCategories;
    };

    this.getCategories = function () {
        return _productCategories;
    };

    this.clearCategories = function () {
        _productCategories = null;
    };

    this.getProductTypeByProductTypeId = function (typeId) {
        if (_productCategories == null) {
            return null;
        }

        const TypeId = parseInt(typeId);

        for (let i = 0; i < _productCategories.length; i++) {
            for (let j = 0; j < _productCategories[i].ProductTypes.length; j++) {
                if (_productCategories[i].ProductTypes[j].EETypeId === TypeId) {
                    return _productCategories[i].ProductTypes[j];
                }
            }
        }
    };

    this.getProductTypeUrl = function (productTypeId, geoStateAbbreviation) {
        const type = this.getProductTypeByProductTypeId(productTypeId);

        return type.NoProducts ? `/product-lookup/detail/${geoStateAbbreviation}/${type.EETypeId}_${type.NoProductProductId}` : `/product-lookup/search/${geoStateAbbreviation}/${type.EETypeId}?query=&filters=`;
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/services/categoryCacheService.js